import { Route, Routes } from 'react-router-dom';
import './App.css';

import { Header } from './components/Header.js';
import { Home } from './components/Home.js';
import { Footer } from './components/Footer';
import { Prices } from './components/Prices';
import { SendImage }  from './components/SendImage.js'
import { Industrial } from './components/Industrial.js';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Header />
      </header>
        <Routes>
          <Route path="/" element={<Home />}/>
          <Route path="/invia un immagine" element={<SendImage />}/>
          <Route path="/personalizza" element={<Prices />}/>
          <Route path="/marcature industriali" element={<Industrial />}/>
        </Routes>
      <footer className="App-footer"><Footer /></footer>
    </div>
  );
}

export default App;
